export default "__VITE_ASSET__HqqSHX9P__"